///<amd-module name="typeahead/core/logging/ProblemOrigin"/>

export enum ProblemOrigin {
    Unspecified,
    ExpediaSuggestService,
    UniversalTypeahead,
    ClientOfUniversalTypeahead,
    DataCaptureToolkit,
}
